//# sourceMappingURL=table.mjs.map
/// <reference types="./table.d.mts" />
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../../../sketch/sketch/css/length.mjs";
import * as $h_ from "../../../../sketch_redraw/sketch/redraw/dom/hooks/html.mjs";
import * as $h from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../../ds/colors.mjs";
import * as $scroll from "../../../ds/providers/scroll.mjs";
import * as $text from "../../../ds/typography/text.mjs";
import { toList } from "../../../gleam.mjs";

export function table_wrapper(overflow, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.overflow(overflow),
      $css.display("grid"),
      $css.grid_template_rows("auto 1fr auto"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function table(columns, attrs, children) {
  return $h_.table(
    attrs,
    children,
    () => {
      let overflow = $scroll.use_overflow();
      let template = columns[1];
      return ((_capture) => {
        return $redraw.use_memo(_capture, [overflow, template]);
      })(
        () => {
          return $css.class$(
            toList([
              $css.border_radius(px(8)),
              $css.border("1px solid " + $colors.light.grey_200),
              $css.display("grid"),
              $css.grid_template_columns(template),
              $css.overflow_x(overflow),
              $css.overflow_y("auto"),
              $css.scrollbar_width("auto"),
              $css.scrollbar_gutter("auto"),
              $css.selector("::-webkit-scrollbar", toList([$css.width(px(13))])),
              $css.selector(
                "::-webkit-scrollbar:horizontal",
                toList([$css.height(px(13))]),
              ),
              $css.selector(
                "::-webkit-scrollbar-thumb",
                toList([
                  $css.box_shadow("inset 0 0 8px 8px " + $colors.light.grey_400),
                  $css.border("solid 2px transparent"),
                  $css.border_radius(px(14)),
                  $css.transition("box-shadow .3s"),
                ]),
              ),
              $css.selector(
                "::-webkit-scrollbar-thumb:vertical",
                toList([$css.border_left_width(px(3))]),
              ),
              $css.selector(
                "::-webkit-scrollbar-thumb:horizontal",
                toList([$css.border_top_width(px(3))]),
              ),
              $css.selector(
                "::-webkit-scrollbar-track:vertical",
                toList([$css.border_left("solid 1px " + $colors.light.grey_200)]),
              ),
              $css.selector(
                "::-webkit-scrollbar-track:horizontal",
                toList([$css.border_top("solid 1px " + $colors.light.grey_200)]),
              ),
              $css.selector(
                ":has(~ tfoot)",
                toList([
                  $css.border_bottom_right_radius(px(0)),
                  $css.border_bottom_left_radius(px(0)),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

export function subgrid(count) {
  let column_end = $int.to_string(count + 1);
  return $css.class$(
    toList([
      $css.display("grid"),
      $css.grid_template_columns("subgrid"),
      $css.grid_column("1 / " + column_end),
    ]),
  );
}

export function thead(columns, attrs, children) {
  let count = columns[0];
  let _pipe = $css.class$(
    toList([
      $css.compose(subgrid(count)),
      $css.border_bottom("1px solid " + $colors.light.grey_200),
      $css.text_align("left"),
      $css.last_child(toList([$css.border_bottom("none")])),
      $css.border_top_right_radius(px(7)),
      $css.border_top_left_radius(px(7)),
      $css.position("sticky"),
      $css.top(px(0)),
      $css.z_index(10_000),
    ]),
  );
  return $h.thead(_pipe, attrs, children);
}

export function thr(column, attrs, children) {
  let count = column[0];
  return $h.tr(
    $css.class$(toList([$css.compose(subgrid(count))])),
    attrs,
    children,
  );
}

export function theader(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.padding(px(8)),
      $css.background($colors.light.grey_100),
      $css.color($colors.light.text_display),
      $css.white_space("nowrap"),
      $css.first_child(toList([$css.padding_left(px(16))])),
      $css.last_child(toList([$css.padding_right(px(16))])),
    ]),
  );
  return $h.th(_pipe, attrs, children);
}

export function tfoot(columns, attrs, children) {
  let columns$1 = $int.to_string(columns);
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.grid_column("span " + columns$1),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_top("none"),
      $css.border_bottom_right_radius(px(8)),
      $css.border_bottom_left_radius(px(8)),
      $css.justify_content("space-between"),
      $css.selector(
        "[disabled='True']",
        toList([$css.pointer_events("none"), $css.opacity(0.3)]),
      ),
    ]),
  );
  return $h.tfoot(_pipe, attrs, children);
}

export function tcell(custom_style, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.padding_("6px 8px"),
      $css.max_width(percent(100)),
      $css.white_space("wrap"),
      $css.hover(toList([$css.background("inherit")])),
      $css.first_child(toList([$css.padding_left(px(16))])),
      $css.last_child(toList([$css.padding_right(px(16))])),
      $css.compose(custom_style),
    ]),
  );
  return $h.td(_pipe, attrs, children);
}

export function tbody(columns, attrs, children) {
  let count = columns[0];
  let _pipe = $css.class$(
    toList([
      $css.compose(subgrid(count)),
      $css.compose($text.sm($text.regular)),
      $css.color($colors.light.text_body),
      $css.white_space("nowrap"),
    ]),
  );
  return $h.tbody(_pipe, attrs, children);
}

export function tr(tag, columns, hover, attrs, children) {
  let count = columns[0];
  let _pipe = $css.class$(
    toList([
      $css.compose(subgrid(count)),
      $css.align_items("center"),
      $css.hover(
        (() => {
          if (hover) {
            return toList([
              $css.background($colors.light.grey_100),
              $css.cursor("pointer"),
            ]);
          } else {
            return toList([]);
          }
        })(),
      ),
    ]),
  );
  return tag(_pipe, attrs, children);
}

export function separator(columns) {
  let count = columns[0];
  let _pipe = $css.class$(
    toList([
      $css.compose(subgrid(count)),
      $css.height(px(1)),
      $css.background($colors.light.grey_200),
    ]),
  );
  return $h.tr(_pipe, toList([]), toList([]));
}

export function semi_separator(columns) {
  let count = columns[0];
  let _pipe = $css.class$(
    toList([
      $css.compose(subgrid(count)),
      $css.height(px(1)),
      $css.background($colors.light.grey_200),
      $css.grid_column("2 / 10"),
      $css.margin_left(px(48)),
    ]),
  );
  return $h.tr(_pipe, toList([]), toList([]));
}

export function footer_dropdown(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.display("flex"), $css.align_items("center"), $css.gap(px(24))]),
  );
  return $h.div(_pipe, attrs, children);
}

export function footer_actions(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.display("flex"), $css.align_items("center"), $css.gap(px(16))]),
  );
  return $h.div(_pipe, attrs, children);
}

export function icon_wrapper(attrs, children) {
  return $h.div(
    $css.class$(toList([$css.width(px(20)), $css.height(px(20))])),
    attrs,
    children,
  );
}

export function empty_cell(child) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.padding_("30px 0"),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([child]));
}

export function empty_text_content(child) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.max_width(px(230)),
      $css.white_space("wrap"),
      $css.text_align("center"),
      $css.color($colors.light.grey_800),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([child]));
}
